import { Component } from 'react';

import bind from 'core/utils/bind';
import breakpointPropTypes from 'core/utils/prop-types/breakpoint';
import viewportBreakpointPropTypes from 'core/utils/prop-types/viewport-breakpoint';

import valueEmitterPropTypes from 'core/utils/prop-types/value-emitter';

export default function withViewportBreakpoint(WrappedComponent) {
  class ViewportBreakpoint extends Component {
    state = {
      viewportBreakpoint: undefined,
    };

    componentDidMount() {
      const { viewportBreakpointEmitter } = this.context;
      if (!viewportBreakpointEmitter) return;

      const handler = bind(this.setViewportBreakpoint, this);

      this.setViewportBreakpoint(viewportBreakpointEmitter.get());
      this.unsubscribe = viewportBreakpointEmitter.subscribe(handler);
    }

    componentWillUnmount() {
      this.unsubscribe && this.unsubscribe();
    }

    setViewportBreakpoint(emittedViewportBreakpoint) {
      const viewportBreakpoint = this.props.viewportBreakpoint || emittedViewportBreakpoint;
      this.setState({ viewportBreakpoint });
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          viewportBreakpoint={this.state.viewportBreakpoint}
          breakpoint={this.context.initialBreakpoint}
        />
      );
    }
  }

  ViewportBreakpoint.contextTypes = {
    viewportBreakpointEmitter: valueEmitterPropTypes,
    initialBreakpoint: breakpointPropTypes(),
  };

  ViewportBreakpoint.propTypes = {
    viewportBreakpoint: viewportBreakpointPropTypes(),
  };

  return ViewportBreakpoint;
}
